export const apiUrl = "https://charhoo.cn"
export const fileUrl = "https://charhoo.cn"
export const filePath = "https://charhoo.cn/file"
// export const apiUrl = "http://localhost"
// export const fileUrl = "https://givehub.cn/givehub/file"